<template>
    <div>
        <!-- 领取福利弹窗 -->
        <div ref="receive_tc" class="receive">
            <div class="recive_body">
                    <div class="tab_title">
                        <!--点击设置curId的值  如果curId等于0，第一个a添加cur类名，如果curId等于1，第二个a添加cur类名，以此类推。添加了cur类名，a就会改变样式 @click,:class ,v-show这三个是vue常用的指令或添加事件的方式-->
                        <a href="javascript:;" @click="reissueForm.reissue_type = 1"
                            :class="{ 'rec_active': reissueForm.reissue_type === 1 }" class="game_title">平台币兑换</a>
                        <a href="javascript:;" @click="reissueForm.reissue_type = 2"
                            :class="{ 'rec_active': reissueForm.reissue_type === 2 }" class="game_title">积分兑换</a>
                        <a href="javascript:;" @click="reissueForm.reissue_type = 5" v-if="userInfo.m_user_mouth"
                            :class="{ 'rec_active': reissueForm.reissue_type === 5 }" class="game_title">包服卡兑换</a>
                        <a href="javascript:;" @click="reissueForm.reissue_type = 6" 
                        :class="{ 'rec_active': reissueForm.reissue_type === 6 }" class="game_title">更多福利</a>
                    </div>
                    <div class="recive_into">
                        <div class="rec_content" v-if="reissueForm.reissue_type != 6">
                            <div class="rec_top">
                                <p>您正在进行：{{ game_name }}的{{ reissueForm.reissue_type == 1 ? '会员充值' : reissueForm.reissue_type == 2 ? '积分兑换' : reissueForm.reissue_type == 5 ? '包服卡兑换' : '月卡点'}}服务</p>
                            </div>
                            <div class="surplus">
                                    <div class="top_text" v-if="reissueForm.reissue_type != 5">
                                        <h5>您剩余可用{{ reissueForm.reissue_type == 1 ? '储值点' : reissueForm.reissue_type == 2 ? '积分' : reissueForm.reissue_type == 5 ? '余额' : '月卡点' }}：
                                            <span>{{ reissueForm.reissue_type == 1 ? store : reissueForm.reissue_type == 2 ? point : reissueForm.reissue_type == 5 ? baofu : yueka }}</span>
                                        </h5>
                                    </div>
                                    <div class="top_text" v-if="reissueForm.reissue_type === 5">
                                        <h5 style="color: red;">您今日可用次数剩余：{{bf_times}} 可用总余额：
                                            <span>{{ reissueForm.reissue_type == 1 ? store : reissueForm.reissue_type == 2 ? point : reissueForm.reissue_type == 5 ? baofu : yueka }}</span>
                                        </h5>
                                    </div>
                                    <span class="tishi" style="margin: 0;" v-if="reissueForm.reissue_type == 1">有转区点的情况下将自动使用 转区点随平台储值点兑换同步扣除（兑多少扣多少） 兑换500储值点=500储值点+500转区点=1000游戏充值 （可在用户中心查看转区点余额）</span>
                            </div>
                            <div class="rec_box ">
                                <div class="rec_lang">
                                    <div class="exchange_right  class_box">
                                        <div class="rec_form ">
                                            <div class="user_box">
                                                <label class="rec_title lang_point" title="游戏账号：">游戏账号：</label>
                                                <div class="lb_1">
                                                    <input class="zhanhao" type="text" maxlength="10" minlength="4" placeholder="请输入游戏账号"
                                                        v-model="reissueForm.account">
                                                </div>
                                            </div>
                                            <div class="rec_form" v-for="item in fl_money" :key="item.id">
                                                <div class="exchange_dami">
                                                    <span class="rec_title  lang_one" :title="game_name + '-' + item.gameCurrencyName">{{ game_name + '- ' + item.gameCurrencyName}}：</span>
                                                    <div>
                                                        <div class="qita_box">
                                                            <input type="text" class="zhanhao"
                                                                @input="inputBlur(item)"
                                                                :placeholder="'请输入' + game_name + '-' + item.gameCurrencyName + '兑换信息'"
                                                                v-model="inputMoney[item.partition_id]">
                                                        </div>
                                                        <div class="lb_2" v-show="reissueForm.reissue_type == 1">
                                                            <a ref="dami" class="dami_btn item_hover"
                                                                :class="{ 'hit_item': moneyCont[item.partition_id] ? moneyCont[item.partition_id].index == index : index == -5 }"
                                                                v-for="(item2, index) in money_btn" :key="item2.id"
                                                                :value="item2.value"
                                                                @click="tabMoney(item, index, item2.value)">
                                                                {{ item2.value }}储值
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="rule_box" v-if="reissueForm.reissue_type == 1">
                                        <span style="color: #ed5565;font-weight: 600;">注意事项（避免造成领取不到的情况）</span>
                                        <span>游戏账号：不能小于4位或大于10位（请手动输入游戏账号）；</span>
                                        <span>兑换信息：填写正确数字（请勿填写特殊符号和空格），若无需兑换此货币请填写“0”；</span>
                                        <span>会员须知：请在会员有效期内使用，过期作废，不可退款；更多问题请联系您的91cq专属客服解答！</span>
                                    </div>
                                    <div class="rule_box" v-if="reissueForm.reissue_type == 2">
                                        <span style="color: #ed5565;font-weight: 600;">注意事项（避免造成领取不到的情况）</span>
                                        <span>有效时间：V1-V3使用有效期为10天，逾期自动清理，请及时使用</span>
                                        <span>游戏账号：不能小于4位或大于10位（请手动输入游戏账号）；</span>
                                        <span>兑换信息：填写正确数字（请勿填写特殊符号和空格），若无需兑换此货币请填写“0”；</span>
                                        <span>兑换规则：非会员每日最多兑换100积分，会员每日最多兑换700积分；</span>
                                        <span>兑换规则：相同游戏账号一天只能兑换一次，请注意兑换失败提示，规范使用平台积分！</span>
                                    </div>
                                    <div class="rule_box" v-if="reissueForm.reissue_type == 5">
                                        <span style="color: #ed5565;font-weight: 600;">注意事项（避免造成领取不到的情况）</span>
                                        <span>游戏账号：不能小于4位或大于10位（请手动输入游戏账号）；</span>
                                        <span>兑换信息：填写正确数字（请勿填写特殊符号和空格），若无需兑换此货币请填写“0”；</span>
                                        <span>兑换须知：VIP1-3级会员用户需在会员有效期内使用包服卡兑换服务；</span>
                                        <span>会员须知：请在会员有效期内使用，过期作废，不可退款；更多问题请联系您的91cq专属客服解答！</span>
                                        <span><font color="red">注意：2025年10月开始取消包服卡兑换！</font></span>
                                        <span style="text-indent: 28px;"><font color="red">包服卡系统于12月1日正式下线！！</font></span>
                                        <span style="text-indent: 28px;"><font color="red">系统下架后可联系平台客服一次性领取1400签到积分补偿！！</font></span>
                                    </div>
                                    <hr v-if="is_under == 1">
                                    <countDown  v-if="is_under == 1" :endTime="endTime" :endText="endText">
                                    </countDown>
                                    <div class="sub_box">
                                        <div class="submit sub_font submit_color "
                                            @click="fl_submit()">{{ is_under == 1 ? '继续兑换' : '提交' }}
                                        </div>
                                        <div class="close submit sub_font qvxiao submit_font_color" ref="closed"
                                            @click="fun2">{{ is_under == 1 ? '我再想想' : '取消' }}</div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="rec_content" v-if="reissueForm.reissue_type === 6">
                            <div class="more_box">
                                <div class="fuli_item" v-for="(item,index) in material.pc_fuli_img" :key="index">
                                    <img class="more_bg" :src="img_url + item.img">
                                    <a v-if="item.jump == 2" @click="toUrl(item.jump_url)" ><img class="fuli_btn btn_hover" :src="img_url + material.pc_tz_tp"></a>
                                    <a v-else ><img class="fuli_btn btn_hover" :src="img_url + material.pc_tz_tp"></a>
                                </div>
                            </div>
                        </div>
                    </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import { mapState } from "vuex";
import { supplyAgain, getGameCurrencyList,getUserYueka,getMouth } from '@/api/http.js'
import countDown from './countDown.vue';
export default {
    name: 'ReceiveBenefits',
    props: ['id', 'game_id','game_name', 'img','under_time','is_under'],
    data() {
        return {
            flag: true,
            account: '', //游戏账号
            money_btn: [
                { id: 1, value: 100 },
                { id: 2, value: 500 },
                { id: 3, value: 1000 },
                { id: 4, value: 5000 },
                { id: 5, value: 10000 },
            ],
            isShow: '',
            fl_money: [], //福利兑换货币种类
            /* 提交补发表单 */
            reissueForm: {
                /* 默认储值兑换 */
                reissue_type: 1
            },
            /* 选中状态存放 */
            moneyCont: {},
            /* input 输入框 */
            inputMoney: {},
            endTime:'',
			//  console.log(endTime)=>得到毫秒  1658030420 可在方法里面放入后台数据,new Date('放后台数据').getTime() / 1000 +  ' ',但要记得调用方法
			endText:'',
            yueka:'', //月卡点数
            baofu:0,//包服卡点数
            bf_times:0,
        }
    },
    components:{
        countDown
    },
    watch: {
        under_time: {
            deep:true,
            immediate:true,
            handler(nval, oval) {
                this.endTime = new Date(nval).getTime() / 1000 +  ' '
            }
        }
    },
    computed: {
        ...mapState([
            'service_id',
            'userStore',
            'userPoint',
            'userInfo',
            'material',
        ]),
        store() {
            return Math.round(this.userStore.available)
        },
        point() {
            return Math.round(this.userPoint.available)
        },
        under_off:{
            get(){
                return this.$store.state.under_off
            },
            set(val){
                return this.$store.state.under_off = val
            }
        }
    },
    methods: {
        toUrl(url){
            window.open(url, '_blank');
        },
         // 获取用户包服卡点数接口
         getMouth(){
            getMouth().then((res)=>{
                if(res.code == 200){
                    if(res.data.uniform){
                        this.baofu = 100
                        this.bf_times = 1
                    }else{
                        this.baofu = 0
                        this.bf_times = 0
                    }
                }
            }).catch((err)=>{
                console.log('捕获异常', err)
                this.$message({
                    message: err.msg,
                    type: 'warning',
                    duration: 1500
                })
            })
        },
        // 获取用户月卡点数接口
        getUserYueka(){
            getUserYueka().then((res)=>{
                if(res.code == 200){
                    this.yueka = Number(res.data.available).toFixed(0)
                }
            }).catch((err)=>{
                console.log('捕获异常', err)
                this.$message({
                    message: err.msg,
                    type: 'warning',
                    duration: 1500
                })
            })
        },
        //获取游戏货币列表
        getGameCurrencyList(id) {
            getGameCurrencyList({
                id
                //   id:1
            }).then((res) => {
                if (res.code === 200) {
                    this.fl_money = res.data
                    this.endText = res.ex_time
                    /* 如果游戏有货币往表单添加渠道 */
                    if (res.data.length > 0) {
                        this.reissueForm.game_reissue = res.data[0].platform
                    }else{
                        this.$message({
                            message: '当前游戏还未开启货币兑换，敬请期待~',
                            type: 'warning',
                            duration: 1500
                        })
                    }
                }
            }).catch((err) => {
                console.log('捕获异常', err)
                this.$message({
                    message: '当前游戏还未开启货币兑换，敬请期待~',
                    type: 'warning',
                    duration: 1500
                })
            })

        },
        open(game_id){
            if(localStorage.getItem('token') && this.userInfo.user_idcard){
                this.getGameCurrencyList(game_id)
            }
        },

        tabMoney(item, index, money) {
            /* 对索引进行赋值实现每个元宝列表独立 */
            this.moneyCont[item.partition_id] = { index }
            /* 给提交表单赋值 */
            this.reissueForm[item.partition_id] = money
            this.$forceUpdate()
            /* 给输入框赋值 */
            this.inputMoney[item.partition_id] = money
        },
        inputBlur(item) {
            /* 输入框输入值清除标签 */
            if (this.moneyCont[item.partition_id]) {
                this.moneyCont[item.partition_id] = null
                delete (this.reissueForm[item.partition_id])
            }
        },
        fl_submit() {
            /* 如果input 有值 加入到表单 */
            for (let key in this.inputMoney) {
                if (this.inputMoney[key]) {
                    this.reissueForm[key] = this.inputMoney[key]
                }
                if (this.inputMoney[key] == '' && this.reissueForm[key] && !this.moneyCont[key]) {
                    /* 如果输入框是空的 表单里有值 并且没有选中标签 删除对于的键名 */
                    delete (this.reissueForm[key])
                }
            }
            this.reissueForm.id = this.id
            if (!this.reissueForm.account) {
                this.Msg('请填写充值账号')
                return
            }

            if (Object.keys(this.reissueForm).length < 5) {
                this.Msg('至少选择一种充值货币')
                return
            }

            this.supplyAgain()
            
        },
        supplyAgain() {
            supplyAgain(this.reissueForm).then((res) => {
                if (res.code == 200) {
                    this.$message({
                        message: res.msg,
                        type: 'success',
                        onClose: () => {
                            this.flag = true
                            this.$refs.closed.click()
                            this.fun2()
                            if (res.data.tan) {
                                const config = JSON.parse(localStorage.getItem('config'))
                                this.$confirm(config.channel_other.fuli_note, '提示', {
                                    confirmButtonText: '是',
                                    cancelButtonText: '否',
                                    type: 'warning',
                                    center: true
                                }).then(() => {
                                    this.$router.push({
                                        path: '/gameDetails', 
                                        query: {
                                            id: res.data.id,
                                            game_id: res.data.game_id,
                                            uid:this.userInfo.id
                                        }
                                    })
                                }).catch(() => {
                                });
                            }
                            // location.reload()
                        },
                        duration: 1500
                    });
                     //判断是否是包服卡兑换
                     if(this.reissueForm.reissue_type === 5){
                        this.getMouth()
                    }
                }
            }).catch((err) => {
                console.log('捕获异常', err)
                this.$message({
                    message: err.msg,
                    type: 'warning',
                    onClose: () => {
                        this.flag = true
                    },
                    duration: 1500
                });
            })
        },

        Msg(text) {
            return this.$message({
                message: text,
                type: 'warning',
                duration: 1500
            })
        },
         // 初始化金额选项
         fun2(){
            this.reissueForm={
                /* 默认储值兑换 */
                reissue_type: 1
            }
            /* 选中状态存放 */
            this.moneyCont= {},
            /* input 输入框 */
            this.inputMoney={}
            /* 货币列表  */
            this.fl_money = []
            if(this.is_under == 1){
                this.under_off = true
                // this.endTime = ''
                console.log('this.under_off',this.under_off)
            }
        }

    },
    created(){
        if(localStorage.getItem('token')){
            this.getUserYueka()
            this.getMouth() // 获取包服卡列表
        }
    }
}
</script>
  
<style scoped>
.more_box{
    display: flex;
    flex-direction: column;
    width: 100%;
}
.fuli_item{
    position: relative;
    margin-bottom: 10px;
}
.more_bg{
    width: 100%;
}
.fuli_btn {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    width: 155px;
}
::v-deep .layui-layer-title{
    background: #fff !important;
}
.count{
    max-width: 45%;
}
.colsing{
    position: absolute;
    right: 1%;
    cursor: pointer;
}
/* 领取福利弹窗 */
.layui-layer-page .layui-layer-content {
    overflow: visible !important;
}

/* 选项卡移入 */
.item_hover:hover {
    border: 1px solid #AC8747 !important;
    color: #805D25 !important;
    transition: all 0.5s;
}

.pay_hover:hover {
    border: 1px solid #AC8747 !important;
    transition: all 0.5s;
}

/* 选项卡点击 */
.hit_item {
    border: 1px solid #AC8747 !important;
    color: #805D25 !important;
}

/* .layui-layer-content {
      overflow: hidden !important;
  } */
.receive {
    background: #f3f3f4;
    padding: 25px;
    display: none;
}
.recive_body{
    background: #fff;
    border: 1px solid #e7eaec;
    border-radius: 4px;
    padding: 20px;
}
.recive_into{
    border: 1px solid #e7eaec;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
}
.tab_title {
    display: flex;
    justify-content: start;
    align-items: center;
    position: relative;
    top: 3px;
}

.rec_active {
    color: #495057 !important;
    border-color: #dee2e6 #dee2e6 #fff !important;
    border-bottom: 5px solid #fff !important;
}

.game_title {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 600;
    color: #A7B1C2;
    text-decoration: none;
    transition: all 0.5s;
    padding: 15px 20px;
    border: 1px solid transparent;
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
}
.rec_content {
    padding: 20px;
}

.rec_content p {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 700;
    margin: 0;
}
.rec_top{
    display: flex;
    align-items: center;
    border-left: 3px solid #409eff;
    padding-left: 5px;
    width: 100%;
}
.surplus {
    width: 100%;
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
}

.surplus h5 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    margin: 0;
}
.rec_box {
    display: flex;
    margin: 20px 0 30px;
}
.rec_lang{
    width: 100%;
    display: flex;
    flex-direction: column;
}

.rec_left {
    width: 20vw;
    display: flex;
    flex-direction: column;
    justify-content: start;
    margin-right: 40px;
}
.exchange_right{
    min-height: 172px;
    overflow: hidden;
}

.class_box{
    overflow: auto;
    padding-right: 12px;
}
.class_box::-webkit-scrollbar {
  /*滚动条整体样式*/
    width : 3px;  /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
    padding: 10px 0;
  }
  .class_box::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 15px;
  box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.2);
  background   : #d1b481;
  }
  .class_box::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 15px;
  background   : #e6e6e6;
  padding: 10px 0;
  }
.rec_form {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
}

.rec_title {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    min-width: 100px;
    margin-bottom: 8px;
}
.top_text{
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
}

.tishi {
    font-size: 12px;
    font-family: SimSun;
    font-weight: 400;
    color: red;
    margin-top: 10px;
}

.mt_20 {
    margin-top: 20px;
}

.user_box {
    display: flex;
    flex-direction: column;
}

.lb_1 {
    display: flex;
    flex-direction: column;
    align-items: start;
}

.zhanhao {
    background-color: #FFFFFF;
    background-image: none;
    border: 1px solid #e5e6e7;
    border-radius: 1px;
    color: inherit;
    display: block;
    padding: 6px 12px;
    transition: border-color 0.15s ease-in-out 0s, box-shadow 0.15s ease-in-out 0s;
    width: 100%;
    height: 31px;
    font-size: .9rem;
}

.exchange_dami {
    display: flex;
    flex-direction: column;
    margin-top: 20px;
}

.lb_2 {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.dami {
    margin: 0;
    margin-top: 20px;
}

.dami_btn {
    text-decoration: none;
    cursor: pointer;
    display: block;
    float: left;
    border: 1px solid #1c84c6;
    border-radius: 15px;
    width: 100px;
    text-align: center;
    position: relative;
    top: 15px;
    font-size: 14px;
    color: #1c84c6;
    margin-right: 10px;
}

.hit {
    position: absolute;
    bottom: 0;
    right: 0;
    display: none;
}

.btn_active {
    display: block;
}

.dami_font {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #4C4C4C;
}

.qita {
    margin-top: 10px;
}

.qita_box {
    display: flex;
    flex-direction: column;
}
.form_qita{
    border: 1px solid #4D4D4D;
}

.money_qita {
    height: 46px;
    border: 1px solid #4D4D4D;
    border-right: none;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    display: flex;
    padding: 0 10px;
    align-items: center;
}

.qita_title {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #4D4D4D;
}
.rule_box{
    padding: 10px;
    margin: 10px 0;
    background: #f6f7f9;
    font-size: 12px;
    color: #1c84c6;
    display: flex;
    flex-direction: column;
}

.sub_box {
    display: flex;
    justify-content: center;
    margin-top: 30px;
}

.submit {
    margin-right: 10px;
    border-radius: 4px;
    padding: 6px 12px;
    text-decoration: none;
    cursor: pointer;
}

.submit_color {
    background: #1c84c6;
    transition: all 0.5s;
}

.submit_color:hover {
    filter: brightness(1.2);
    transition: all 0.5s;
}

.qvxiao {
    background: #fff;
    border: 1px solid #e7eaec;
    transition: all 0.5s;
}

.qvxiao:hover {
    transition: all 0.5s;
    border: 1px solid #ccc;
}

.sub_font {
    font-size: 14px;
    font-family: SimSun;
    font-weight: 400;
    color: #fff;
}

.submit_font_color {
    color: #000;
    transition: all 0.5s;
}

.submit_font_color:hover {
    transition: all 0.5s;
    color: #000;
}

/*  */
@media (max-width:1600px) {

    /* 福利弹窗 */
    .exchange_right{
        max-height: 300px;
    }
    .rec_content {
        padding: 20px 40px 30px;
    }

    .game_title {
        font-size: 16px;
        padding: 15px 0 18px;
    }

    .rec_content p {
        font-size: 14px;
    }

    .surplus h5 {
        font-size: 16px;
    }

    .submit {
        padding: 10px 40px;
    }
}

@media (max-width:1300px) {

    /* 领取福利弹窗 */
    .rec_content {
        padding: 20px 40px 25px;
    }

    .game_title {
        font-size: 14px;
        padding: 10px 0 15px;
    }

    .rec_content p {
        font-size: 14px;
    }

    .surplus h5 {
        font-size: 15px;
    }

    .rec_title {
        font-size: 14px;
    }

    .zhanhao {
        height: 35px;
        width: 270px;
    }

    .dami_font {
        font-size: 12px;
    }

    .dami_btn {
        padding: 5px 10px;
    }

    .qita_title {
        font-size: 12px;
    }

    .money_qita {
        height: 35px;
    }

    .submit {
        margin-right: 10px;
        padding: 10px 30px;
    }

    .sub_box {
        margin-top: 15px;
        margin-left: 70px;
    }

    .exchange_dami {
        margin-top: 10px;
    }
}

@media (max-width:1100px) {
    /* 福利领取弹窗 */

    .rec_content {
        padding: 20px;
    }

    .game_title {
        font-size: 12px;
        padding: 5px 0;
    }

    .rec_content p {
        font-size: 12px;
    }

    .surplus {
        height: 35px;
    }

    .surplus h5 {
        font-size: 13px;
    }

    .rec_box {
        margin-top: 15px;
    }

    .rec_title {
        font-size: 12px;
    }

    .zhanhao {
        height: 25px;
    }

    .dami_btn {
        margin-top: 0;
    }

    .submit {
        padding: 5px 25px;
    }
}
</style>